// Formatting that refuses to print a number nobody gave us.
//
// Every formatter here takes either a plain number or one of the fields from
// `assessmentFacts`, and an unrecorded field comes back as words rather than as
// a dash or a zero. That is the difference the whole design rests on, so it
// lives in one place instead of in each view's ternary.

import { isKnown } from '../../store/assessmentFacts.js';

export const NOT_RECORDED = 'Not recorded';

function valueOf(input) {
  if (input === null || input === undefined) return null;
  if (typeof input === 'number') return Number.isFinite(input) ? input : null;
  return isKnown(input) ? input.value : null;
}

export function money(input, fallback = NOT_RECORDED) {
  const v = valueOf(input);
  if (v === null) return fallback;
  return `$${Math.round(v).toLocaleString('en-US')}`;
}

export function compact(input, fallback = NOT_RECORDED) {
  const v = valueOf(input);
  if (v === null) return fallback;
  const abs = Math.abs(v);
  if (abs >= 1e6) return `$${(v / 1e6).toFixed(2).replace(/0$/, '')}M`;
  if (abs >= 1000) return `$${Math.round(v / 1000)}k`;
  return money(v);
}

// A negative net worth is a real answer, and the minus belongs outside the
// dollar sign where a reader expects it.
export function signedCompact(input, fallback = 'Not available') {
  const v = valueOf(input);
  if (v === null) return fallback;
  return (v < 0 ? '−' : '') + compact(Math.abs(v));
}

export const ROMAN = ['i.', 'ii.', 'iii.', 'iv.', 'v.', 'vi.', 'vii.', 'viii.', 'ix.', 'x.', 'xi.', 'xii.', 'xiii.', 'xiv.', 'xv.', 'xvi.'];

// What the income comes to while Social Security is the one figure missing:
// what is recorded, and the benefit named as still to come, never a zero.
export function soFar(income) {
  if (income.incomeSoFar !== null && income.incomeSoFar !== undefined && income.incomeSoFar > 0) {
    return `${money(income.incomeSoFar)} + Social Security`;
  }
  return 'Social Security not recorded';
}
